module.exports = __webpack_public_path__ + "static/media/icons-02.691345aa.png";